const usDateFormatRegexPattern = '(0[1-9]|1[0-2])\\/(0[1-9]|1\\d|2\\d|3[01])\\/(19|20)\\d{2}';
const ruDateFormatRegexPattern = '(0[1-9]|1\\d|2\\d|3[01])\\.(0[1-9]|1[0-2])\\.(19|20)\\d{2}';
const dateFormatRegexPattern = usDateFormatRegexPattern + '|' + ruDateFormatRegexPattern;

export const dateFormatValidation = (fromId, toId) => {
    const datePickerFrom = document.getElementById(fromId);
    const datePickerTo = document.getElementById(toId);

    if (datePickerFrom && datePickerTo) {
        datePickerFrom.pattern = dateFormatRegexPattern;
        datePickerTo.pattern = dateFormatRegexPattern;
    }
};
